import { IonItem, IonLabel, IonNavLink } from "@ionic/react";
import { IPromptOption } from "./singleSelectNav";

interface IProps {
  opt: IPromptOption;
  onNav: (opt: IPromptOption) => React.ReactElement;
}
export default function SingleSelectNavLink({ opt, onNav }: IProps) {
  return (
    <IonNavLink routerDirection="forward" component={() => onNav(opt)}>
      <IonItem detail button>
        <IonLabel className="ion-text-wrap">
          <h2>{opt.name}</h2>
          {opt.desc ? <p>{opt.desc}</p> : undefined}
        </IonLabel>
      </IonItem>
    </IonNavLink>
  );
}
